import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register the service worker so Web Push (and future PWA features) can run in the background.
// No-op on browsers that don't support service workers.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {
      // Silent — a failed SW registration shouldn't break the app.
    });
  });
}

// Hide the Capacitor splash screen once React has mounted and the first
// paint is on screen. `launchAutoHide` is `false` in capacitor.config.js
// specifically so we get to control this moment — otherwise the splash
// disappears BEFORE React paints, leaving a jarring white gap.
// No-op on the web (the plugin is a native-only bridge).
import("@capacitor/splash-screen")
  .then(({ SplashScreen }) => {
    // requestAnimationFrame guarantees the first React frame is on screen.
    requestAnimationFrame(() => {
      SplashScreen.hide({ fadeOutDuration: 400 }).catch(() => { /* web: no-op */ });
    });
  })
  .catch(() => { /* plugin not installed on this surface — safe to ignore */ });
